import { render, staticRenderFns } from "./UserServicepointsApprovalsTable.vue?vue&type=template&id=43223813&scoped=true"
import script from "./UserServicepointsApprovalsTable.vue?vue&type=script&lang=ts"
export * from "./UserServicepointsApprovalsTable.vue?vue&type=script&lang=ts"
import style0 from "./UserServicepointsApprovalsTable.vue?vue&type=style&index=0&id=43223813&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43223813",
  null
  
)

export default component.exports